import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4293d7c5&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4293d7c5')) {
      api.createRecord('4293d7c5', component.options)
    } else {
      api.reload('4293d7c5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4293d7c5&", function () {
      api.rerender('4293d7c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/system-manage/role-manage/index.vue"
export default component.exports